
import React from 'react';
import { Link } from 'react-router-dom';

function ServicesSection() {
  return (
    <div className="our-services dark-section">
      <div className="container">
        <div className="row section-row align-items-center">
          <div className="col-lg-12">
            <div className="section-title section-title-center">
              <h3 className="wow fadeInUp">our services</h3>
              <h2 className="text-anime-style-2" data-cursor="-opaque">Reliable truck & moving services in Coimbatore, Tiruppur built <span>around you</span></h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="service-item wow fadeInUp">
              <div className="icon-box">
                <img src="/hellotruck-web-images/icon-service-item-1.svg" alt="" />
              </div>
              <div className="service-content">
                <h3><Link to="/services">Residential Moving</Link></h3>
                <p>Hassle-free home relocation services tailored to your needs. to your needs.</p>
              </div>
              <div className="service-btn">
                <Link to="/services" className="readmore-btn">read more</Link>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="service-item wow fadeInUp" data-wow-delay="0.2s">
              <div className="icon-box">
                <img src="/hellotruck-web-images/icon-service-item-2.svg" alt="" />
              </div>
              <div className="service-content">
                <h3><Link to="/services">Commercial Moving</Link></h3>
                <p>Professional moving services tailored to business ensuring efficient timely relocations.</p>
              </div>
              <div className="service-btn">
                <Link to="/services" className="readmore-btn">read more</Link>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="service-item wow fadeInUp" data-wow-delay="0.4s">
              <div className="icon-box">
                <img src="/hellotruck-web-images/icon-service-item-3.svg" alt="" />
              </div>
              <div className="service-content">
                <h3><Link to="/services">Specialty Item Moving</Link></h3>
                <p>Expert handling for fragile and valuable items, ensuring safe transport of antiques.</p>
              </div>
              <div className="service-btn">
                <Link to="/services" className="readmore-btn">read more</Link>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="service-item wow fadeInUp" data-wow-delay="0.6s">
              <div className="icon-box">
                <img src="/hellotruck-web-images/icon-service-item-4.svg" alt="" />
              </div>
              <div className="service-content">
                <h3><Link to="/services">Eco-Friendly Moving</Link></h3>
                <p>Sustainable moving solutions using eco-friendly materials and practices to reduce.</p>
              </div>
              <div className="service-btn">
                <Link to="/services" className="readmore-btn">read more</Link>
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="section-footer-text wow fadeInUp" data-wow-delay="0.8s">
              <p>Expert packing for your move. <Link to="/contact">Contact us now</Link></p>
              <Link to="/services" className="btn-default btn-highlighted">view all services</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicesSection;
